import React, { Component } from 'react'
import { Card, Button } from 'react-bootstrap'
import * as actions from '../actions'
import { connect } from 'react-redux'
import { reduxForm } from 'redux-form'
import MuiTable from '../../Forms/SharedComponents/containers/MuiTable'
import {
  TABLA_COEM_HISTORIAL
} from '../../../config/tables'
class DialogoCOEMsHistorial extends Component {
  async componentDidMount () {
    const {
      id
    } = this.props
    // this.props.getConsultaCoem(id, this.props.change)
    this.props.actualizarDatosHistorialCoemsParaMuiTable(id)
  }

  render () {
    const {
      handleClose
    } = this.props

    return (
      <div>
        <Card style={{ border: 'none' }}>
          <Card.Header style={{ backgroundColor: '#3f51b5', color: '#ffffff' }}>
            <Card.Text style={{ fontSize: '1.3rem', textAlign: 'center' }}>Historial de COEM</Card.Text>
          </Card.Header>
          <Card.Body>
            <MuiTable id={TABLA_COEM_HISTORIAL} />
          </Card.Body>
          <div style={{ display: 'flex', justifyContent: 'center' }}>
            <Button style={{ margin: '2%' }} onClick={handleClose} >Cerrar</Button>
          </div>
        </Card>
      </div>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    consultaCoem: state.comunicacionEmbarque.consultaCoem
  }
}

const withRedux = connect(mapStateToProps, actions)

const withReduxForm = reduxForm({
  enableReinitialize: true,
  keepDirtyOnReinitialize: true,
  destroyOnUnmount: false,
  updateUnregisteredFields: true
})

export default withRedux(withReduxForm(DialogoCOEMsHistorial))
